export default __webpack_public_path__ + "assets/thermometer.08fc871b.svg";